import { useGetBusinessAddressQuery } from "types/generated/operations";
import BussinessAddress from "./BussinessAddress";
import { getProspectUuid } from "utils/idHelpers";
import Loader from "uicomponents/Loader";
import Error from "uicomponents/Error";
interface IBusinessDetailsProps {
  setNextStep: () => void;
  setPreviousStep: () => void;
}

const BussinessAddressModel = ({ ...props }: IBusinessDetailsProps) => {
  const { data, error, loading } = useGetBusinessAddressQuery({
    variables: { uuid: getProspectUuid() },
    fetchPolicy: "no-cache",
  });
  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <Error />;
  }
  return (
    <BussinessAddress
      setNextStep={props.setNextStep}
      setPreviousStep={props.setPreviousStep}
      data={data?.prospect}
    />
  );
};

export default BussinessAddressModel;
